import Properties from '@/services/Rest/Properties';

export default {
	state: {
		properties: [],
		propertiesTotal: {
			current_page: 0,
			last_page: 2
		},
		deletedProperties: [],
		propertiesDeleteTotal: {
			current_page: 0,
			last_page: 2
		},
		draftsProperties: [],
		propertiesDraftTotal: {
			current_page: 0,
			last_page: 2
		},
		verifiedProperties: {},
		totals: {
			total_active: '',
			total_deleted: '',
			total_draft: ''
		},
		matches: {},
		leadsPagination: {},
		leadsCount: {},
		stagesPagination: {},
		filtersProperties: [],
		customersForMatching: {
			next: '',
			current_page: '',
			customers: []
		},
		customersForMatchingPopupMatchProperty: {
			next: '',
			current_page: '',
			last_page: '',
			customers: []
		},
		initital: true,
		propertyInfo: {},
		currentSelected: { name: '', color: '', id: '' },
		isAllSelected: false,
		countLeadProperty: 0
	},
	actions: {
		actionIsAllSelectedProperty({ commit }, data) {
			commit('updateIsAllSelectedProperty', data);
		},
		async matchingPropertiesByStage({ commit, dispatch }, data) {
			const res = await Properties.matchingPropertiesByStage(data);
			commit('setMatchesPaginationProperty', { data: res.data, paginationInfo: data });
		},
		async assignPropertyToStageNew({ commit, state }, data) {
			let res;
			if (data.req[0].stageRow === 'Lead') {
				const stagesArr = state.matches.lead;
				if (!state.isAllSelected) { // ex
					res = await Properties.assignPropertyToStage({ data: data.req, notIn: [], all: false, filter: data.filter, id: data.id });
				} else { // all
					const ids = data.req.map(item => item.customer_id);
					const notIn = stagesArr.filter(item => !ids.includes(item.id)).map(item => item.id);
					res = await Properties.assignPropertyToStage({ data: data.req, notIn, all: true, filter: data.filter, id: data.id });
				}
				if (res.data.count_lead) {
					state.countLeadProperty = state.countLeadProperty - res.data.count_lead;
				}
				
				const obj = {
					id: data.id,
					order: data.order,
					order_by: data.order_by,
					page: 1,
					filter: data.filter
				};
				const ress = await Properties.matchingProperties(obj);
				commit('setLeadsPagination', { data: ress.data, paginationInfo: data });
				commit('leadsCount', ress.data.count_stage);
				commit('leadsCountProperty', ress.data.total);
				commit('setPropertyInfo', ress.data.property_data);
				commit('setMatchesProperties', { data: ress.data.matches, paginationInfo: data });
			} else {
				const stagesArr = state.matches.stages[`st_${data.req[0].stageRow.replaceAll(' ', '_')}`];
				if (!state.isAllSelected) { // ex
					res = await Properties.assignPropertyToStage({ data: data.req, notIn: [], all: false });
				} else { // all
					const ids = data.req.map(item => item.property_id);
					const notIn = stagesArr.filter(item => !ids.includes(item.id)).map(item => item.id);
					res = await Properties.assignPropertyToStage({ data: data.req, notIn, all: true });
				}
				if (res.data.count_lead && data.req[0].stage_name === 'Lead') {
					state.countLeadProperty = state.countLeadProperty + res.data.count_lead;
				}
				
				if (data.req[0].stage_name === 'Lead') {
					const obj = {
						id: data.id,
						order: data.order,
						order_by: data.order_by,
						page: 1,
						filter: data.filter
					};
					const ress = await Properties.matchingProperties(obj);
					commit('setLeadsPagination', { data: ress.data, paginationInfo: data });
					commit('leadsCount', ress.data.count_stage);
					commit('leadsCountProperty', ress.data.total);
					commit('setPropertyInfo', ress.data.property_data);
					commit('setMatchesProperties', { data: ress.data.matches, paginationInfo: data });
				}
			}

			commit('changeIfAll', res.data.count_stage);
			commit('updateIsAllSelectedProperty', false);
			commit('resetAllStages');
			return Promise.resolve(data);
		},
		resetCustomerSelectAll({ commit }) {
			commit('updateIsAllSelectedProperty', false);
		},
		async assignPropertyToStage({ commit, dispatch }, data) {
			const res = await Properties.assignPropertyToStage(data);
			dispatch('mutationMatches', res);
		},
		fetchProperties({ commit, dispatch }, obj) {
			// commit('setProperties', { data: [], isFilter: true });
			if (obj.isFilter) commit('resetTotals');
			return Properties.getProperties(obj).then(response => {
				if (obj.page !== 'csv') {
					commit('setProperties', { data: response.data.properties, isFilter: obj.isFilter });
					commit('setPropertiesInfinitResult', response.data);
					if (obj.isFilter) commit('setTotals', response.data);
				}

				return Promise.resolve(response);
			});
		},
		fetchCommercialProperties({ commit, dispatch }, obj) {
			return Properties.getCommercialProperties(obj).then(response => {
				if (obj.page !== 'csv') {
					commit('setProperties', { data: response.data.properties, isFilter: obj.isFilter });
					commit('setPropertiesInfinitResult', response.data);
				}
				return Promise.resolve(response);
			});
		},
		fetchMapMarkers({ commit, dispatch }, obj) {
			return Properties.getMapMarkers(obj).then(response => {
				return Promise.resolve(response);
			});
		},
		fetchProperty({ commit, dispatch }, id) {
			return Properties.getProperty(id).then(
				response => { return Promise.resolve(response); },
				error => { return Promise.reject(error); }
			);
		},
		fetchDeletedProperty({ commit, dispatch }, id) {
			return Properties.getDeletedProperty(id);
		},
		fetchDropDownOptions({ commit, dispatch }, obj) {
			return Properties.dropDownOptions(obj);
		},
		updateProperty({ commit, dispatch }, property) {
			return Properties.updateProperty(property).then(
				response => { return Promise.resolve(response); },
				error => { return Promise.reject(error); }
			);
		},
		deleteProperty({ commit, dispatch }, data) {
			return Properties.deleteProperty(data);
		},
		fetchDeletedProperties({ commit, dispatch }, obj) {
			return Properties.getDeletedProperties(obj).then(response => {
				response.data.properties.forEach(property => {
					if (property.area_label.includes('Near Boro Park')) {
						property.area_label = ['Brooklyn'];
					}
					
					if (property.area_label.includes('Near Brooklyn')) {
						property.area_label = ['New Jersey'];
					}
				});
				if (obj.page !== 'csv') {
					commit('setDeletedProperties', { data: response.data.properties, isFilter: obj.isFilter });
					commit('setPropertiesDeleteInfinitResult', response.data);
					if (obj.isFilter) commit('resetTotals');
					if (obj.isFilter) commit('setTotals', response.data);
				}

				return Promise.resolve(response);
			});
		},
		fetchDraftsProperties({ commit, dispatch }, obj) {
			return Properties.getDraftsProperties(obj).then(response => {
				if (obj.page !== 'csv') {
					if (obj.isFilter) commit('resetTotals');
					commit('setDraftsProperties', { data: response.data.properties, isFilter: obj.isFilter });
					commit('setPropertiesDraftInfinitResult', response.data);
					if (obj.isFilter) commit('setTotals', response.data);
				}

				return Promise.resolve(response);
			});
		},
		restoreProperty({ commit, dispatch }, data) {
			return Properties.restoreProperty(data);
		},
		destroyProperty({ commit, dispatch }, data) {
			return Properties.destroyProperty(data);
		},
		fetchNewDeletedProperties({ commit, dispatch }, obj) {
			if (obj.isFilter) commit('resetTotals');
			return Properties.getSortedDeletedProperties(obj).then(response => {
				commit('setDeletedProperties', { data: response.data.properties, isFilter: obj.isFilter });
				commit('setPropertiesDeleteInfinitResult', response.data);
				if (obj.isFilter) commit('setTotals', response.data);

				return Promise.resolve(response);
			});
		},
		async fetchUnpersonalizedPdf({ commit, dispatch }, id) {
			const pdf = await Properties.getUnpersonalizedPdf(id);
			return pdf?.data?.pdf_path || '';
		},
		fetchNewDraftsProperties({ commit, dispatch }, obj) {
			// TODO: fix filters reset
			return Properties.getSortedDraftsProperties(obj).then(response => {
				if (obj.isFilter) commit('resetTotals');
				commit('setDraftsProperties', { data: response.data.properties, isFilter: obj.isFilter });
				commit('setPropertiesDraftInfinitResult', response.data);
				if (obj.isFilter) commit('setTotals', response.data);

				return Promise.resolve(response);
			});
		},
		// Get matches for property
		async matchingProperties({ commit, dispatch, state }, data) {
			const res = await Properties.matchingProperties(data);
			commit('setLeadsPagination', { data: res.data, paginationInfo: data });
			commit('leadsCount', res.data.count_stage);
			commit('leadsCountProperty', res.data.total);
			commit('setPropertyInfo', res.data.property_data);

			if (state.initital) {
				const newFilters = res.data.filters.map(el => {
					el.labels.map(el => {
						el.show = true;
						return el;
					});
					return el;
				});
				if (res.data.filters && res.data.filters.length > 0) {
					commit('setFilters', newFilters);
				}
			} else {
				if (res.data.filters && res.data.filters.length > 0) {
					commit('setFilters', res.data.filters);
				}
			}
			commit('resetInititalProperty', false);
			commit('setMatchesProperties', { data: res.data.matches, paginationInfo: data });
		},
		// Get sorted leads for properties
		async sortPropertiesLeads({ commit, dispatch }, data) {
			const res = await Properties.matchingProperties(data);

			commit('setMatchesProperties', res.data.matches);
		},
		//	Assign customer to stage for property
		async assignCustomerToStage({ commit, dispatch }, data) {
			const res = await Properties.assignCustomerToStage(data);
			dispatch('mutationMatches', res);
		},
		// Set changes of stages
		mutationMatches({ commit, state }, data) {
			const newData = JSON.parse(JSON.stringify(state.matches));
			const newStages = data.data.matches.stages;

			for (const key in newStages) {
				newData.stages[key] = newStages[key];
			}
			newData.lead = data.data.matches.lead;
			commit('setMatchesProperties', newData);
		},
		// Set changes of filters
		async mutationFiltersProperties({ commit, state }, data) {
			const res = await Properties.matchingProperties(data);
			commit('setLeadsPagination', { data: res.data, paginationInfo: data });
			commit('setDataCustomers', res.data);
			commit('leadsCount', res.data.count_stage);
			commit('leadsCountProperty', res.data.total);
			commit('setMatchesProperties', { data: res.data.matches, paginationInfo: data });
			commit('setCustomerInfo', res.data.customer_data);
		},
		togglePillsProperties({ commit, state }, data) {
			commit('setNewFiltersProperties', data);
		},
		enablePillsProperties({ commit, state }, data) {
			commit('enableFiltersProperties', data);
		},
		// Get customers for matching with current property
		customersForMatching({ commit, dispatch }, filter) {
			return Properties.getCustomersForMatching(filter).then(response => {
				commit('setCustomersForMatching', response.data);

				return Promise.resolve(response);
			});
		},
		customersForMatchingPopupMatchProperty({ commit, dispatch }, filter) {
			return Properties.getCustomersForMatching(filter).then(response => {
				commit('setCustomersForMatchingPopupMatchProperty', { scroll: filter.scroll, next: response.data.next, current_page: response.data.current_page, customers: response.data.customers, last_page: response.data.last_page });
				return Promise.resolve(response);
			});
		},
		verifiedProperties({ commit, dispatch }, obj) {
			return Properties.getVerifiedProperties(obj).then(response => {
				commit('setVerifiedProperties', response.data.properties);

				return Promise.resolve(response);
			});
		},
		sendVerificationEmail({ commit, dispatch }, data) {
			return Properties.sendVerificationEmail(data);
		},
		// Update after send email
		async emailUpdateProperties({ commit, dispatch }, data) {
			const res = await Properties.matchingProperties(data.payload);
			commit('leadsCount', res.data.count_stage);
			commit('emailUpdatePropertiesByCustomerId', data);
		},
		neighborhoodSearch({ commit, dispatch }, data) {
			return Properties.neighborhoodSearch(data).then(response => {
				commit('neighborhoodSearch', response.data);

				return Promise.resolve(response);
			});
		},
		getAssigned({ commit, dispatch }, data) {
			return Properties.getAssigned(data).then(response => {
				commit('getAssigned', response.data);

				return Promise.resolve(response);
			});
		},
		// Check if property with this address already exists
		checkPropertyAddress({ commit, dispatch }, obj) {
			return Properties.checkPropertyAddress(obj);
		},
		// Delete history row from Property History popup
		deleteHistoryRow({ commit, dispatch }, data) {
			return Properties.deleteHistoryRow(data);
		},
		resetInititalProperty({ commit }, data) {
			commit('resetInititalProperty', data);
		}
	},
	mutations: {
		resetInititalProperty(state, data) {
			state.initital = data;
		},
		resetAllStages(state) {
			state.matches.stages = {};
		},
		emailUpdatePropertiesByCustomerId(state, data) {
			const customerIds = data.obj.customer_id;
			customerIds.forEach((id) => {
				const index = state.matches.lead.findIndex(item => item.id === id);
				// Remove object from stage
				state.matches.lead.splice(index, 1);
				state.countLeadProperty = state.countLeadProperty - 1;
			});
		},
		changeIfAll(state, data) {
			state.leadsCount = data;
		},
		leadsCountProperty(state, data) {
			state.countLeadProperty = data;
		},
		updateIsAllSelectedProperty(state, data) {
			state.isAllSelected = data;
		},
		leadsCount(state, data) {
			state.leadsCount = data;
		},
		setLeadsPagination(state, obj) {
			state.leadsPagination = {
				current_page: obj.data.current_page,
				last_page: obj.data.last_page,
				sort_by: obj.paginationInfo.order_by,
				order: obj.paginationInfo.order
			};
		},
		setMatchesPaginationProperty(state, obj) {
			const matches = obj.data.matches;
			for (const key in matches) {
				if (obj.paginationInfo.page === 1) {
					state.matches.stages[key] = matches[key];
				} else {
					state.matches.stages[key] = [...state.matches.stages[key], ...matches[key]];
				}
				state.stagesPagination[key] = {
					current_page: obj.data.current_page,
					last_page: obj.data.last_page,
					sort_by: obj.paginationInfo.order_by,
					order: obj.paginationInfo.order
				};
			}
		},
		setPropertiesInfinitResult(state, data) {
			state.propertiesTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setPropertiesDraftInfinitResult(state, data) {
			state.propertiesDraftTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setPropertiesDeleteInfinitResult(state, data) {
			state.propertiesDeleteTotal = {
				current_page: data.current_page,
				last_page: data.last_page
			};
		},
		setProperties(state, obj) {
			state.properties = obj.isFilter ? obj.data : [...state.properties, ...obj.data];
		},
		setDeletedProperties(state, obj) {
			state.deletedProperties = obj.isFilter ? obj.data : [...state.deletedProperties, ...obj.data];
		},
		setDraftsProperties(state, obj) {
			state.draftsProperties = obj.isFilter ? obj.data : [...state.draftsProperties, ...obj.data];
		},
		setTotals(state, data) {
			state.totals.total_active = data.total_active;
			state.totals.total_deleted = data.total_deleted;
			state.totals.total_draft = data.total_draft;
		},
		resetTotals(state) {
			state.totals = {
				total_active: '',
				total_deleted: '',
				total_archived: ''
			};
		},
		updateMatchesProperties(state, data) {
			state.matches = data.data.matches;
			state.customersForMatching = {
				next: data.data.customers_for_matching.next,
				current_page: data.data.customers_for_matching.current_page,
				customers: data.data.customers_for_matching.customers
			};
		},
		setMatchesProperties(state, obj) {
			if (obj.paginationInfo.page === 1) {
				state.matches = obj.data;
			} else {
				state.matches.lead = [...state.matches.lead, ...obj.data.lead];
			}
		},
		setFilters(state, data) {
			state.filtersProperties = data;
		},
		setNewFiltersProperties(state, data) {
			state.filtersProperties.forEach(el => {
				if (el.key === data.key) {
					el.labels.forEach(el => {
						if (data.flag) {
							el.show = false;
						} else {
							if (el.value === data.item.value) {
								el.show = !el.show;
							}
						}
					});
				}
			});
		},
		enableFiltersProperties(state, data) {
			state.filtersProperties.forEach(el => {
				if (el.key === data.key) {
					el.labels.forEach(el => {
						el.show = !data.status;
					});
				}
			});
		},
		setCustomersForMatching(state, data) {
			state.customersForMatching = {
				next: data.next,
				current_page: data.current_page,
				customers: data.customers
			};
		},
		setCustomersForMatchingPopupMatchProperty(state, data) {
			state.customersForMatchingPopupMatchProperty = {
				next: data.next,
				current_page: data.current_page,
				customers: data.scroll ? [...state.customersForMatchingPopupMatchProperty.customers, ...data.customers] : data.customers,
				last_page: data.last_page
			};
		},
		setVerifiedProperties(state, data) {
			state.verifiedProperties = data;
		},
		setPropertyInfo(state, data) {
			state.propertyInfo = data;
		},
		neighborhoodSearch(state, data) {
			state.neighborhoodSearch = {
				next: data.results
			};
		},
		getAssigned(state, data) {
			state.getAssigned = {
				next: data.results
			};
		}
	},
	getters: {
		getCountLeadPropertyProperty(state) {
			return state.countLeadProperty;
		},
		getLeadsCountProperty(state) {
			return state.leadsCount;
		},
		getLeadsPaginationProperty(state) {
			return state.leadsPagination;
		},
		getStagesPaginationProperty(state) {
			return state.stagesPagination;
		},
		getPropertiesInfinitResult(state) {
			return state.propertiesTotal;
		},
		getPropertiesDraftInfinitResult(state) {
			return state.propertiesDraftTotal;
		},
		getPropertiesDeleteInfinitResult(state) {
			return state.propertiesDeleteTotal;
		},
		getProperties(state) {
			return state.properties;
		},
		getCommercialProperties(state) {
			return state.properties;
		},
		getDeletedProperties(state) {
			return state.deletedProperties;
		},
		getDraftsProperties(state) {
			return state.draftsProperties;
		},
		getAllTotals(state) {
			return state.totals;
		},
		getMatchesProperties(state) {
			return state.matches;
		},
		getFiltersProperties(state) {
			return state.filtersProperties;
		},
		getCustomersForMatching(state) {
			return state.customersForMatching;
		},
		getCustomersForMatchingPopupMatchProperty(state) {
			return state.customersForMatchingPopupMatchProperty;
		},
		getVerifiedProperties(state) {
			return state.verifiedProperties;
		},
		getPropertyInfo(state) {
			return state.propertyInfo;
		},
		getIsAllSelected(state) {
			return state.isAllSelected;
		}
	}
};
